import { render, staticRenderFns } from "./RemoveCompanyUserRoleDialog.vue?vue&type=template&id=6e600a18"
import script from "./RemoveCompanyUserRoleDialog.vue?vue&type=script&lang=ts"
export * from "./RemoveCompanyUserRoleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports